import { getMyTodos, completeTodo, updateTodo } from '@/api/task'

export default {
  state: {},
  mutations: {},
  actions: {
    loadMyTodos: function () {
      return getMyTodos()
    },
    completeTodo: function ({ commit }, id) {
      return completeTodo(id)
    },
    updateTodo: function ({ commit }, { id, data }) {
      return updateTodo(data, id)
    }
  }
}
